<template>
  <Header />
  <div class="section container">
    <div class="content" v-if="orderPlaced">
      <div class="full-page-confirmation">
        <p>Order recreated successfully!</p>
      </div>
    </div>
  </div>
  <div class="section section--pb">
    <div class="customer-top">
      <div class="content-sm">
        <div class="d-flex columns">
          <div class="col-num " :class="'col-num--'+user.tier">
            {{ user.tier }}
          </div>
          <div class="customer-top__info">
            <div class="top-caption">Recreating Order for:</div>
            <h1>{{ user.first_name }} {{ user.last_name }}</h1>
            <div class="d-flex customer__switch-box customer__switch-box--active">
              <div class="d-flex switch-group">
                <input class="switch" type="checkbox" id="switch" checked v-model="matchedResults" @change="loadResults" />
                <label for="switch"></label>
              </div>
              <div class="customer__list" v-if="userRetrieved">
                <span>Saved Sizes:</span>

                <span>Tops: {{ user.tops_sizes_confirmed ? this.sortedSizes(user.tops).map((size) => `${size}*`).join(', ') : this.sortedSizes(user.tops).join(', ') }}</span>
                <span>Bottoms: {{ user.bottoms_sizes_confirmed ? this.sortedSizes(user.bottoms).map((size) => `${size}*`).join(', ') : this.sortedSizes(user.bottoms).join(', ') }}</span>
                <span>Headwear: {{ user.headwear_sizes_confirmed ? this.sortedHeadWearSizes(user.fitted_hats).map((size) => `${size}*`).join(', ') : this.sortedHeadWearSizes(user.fitted_hats).join(', ') }}</span>
                <span>Footwear: {{ user.footwear_sizes_confirmed ? user.footwear.map((s) => parseInt(s)).sort((a, b) => a - b).map((size) => `${size}*`).join(', ') : user.footwear.map((s) => parseInt(s)).sort((a, b) => a - b).join(', ') }}</span>
                <span>Accessories: {{ user.accessories_sizes_confirmed ? this.sortedSizes(user.accessories).map((size) => `${size}*`).join(', ') : this.sortedSizes(user.accessories).join(', ') }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="tabs" data-simplebar>
      <div class="content-sm">
        <ul class="tabs-nav">
          <li><a href="#" data-tab="tab-live-product" class="btn tab-toggle" :class="allProducts ? 'active' : ''" @click="liveProductActive">Live Product</a></li>
          <li><a href="#" data-tab="tab-draft-product" class="btn tab-toggle" :class="allProducts ? '' : 'active'" @click="draftProductActive">Draft Product</a></li>
        </ul>
      </div>
    </div>
    <div class="form product-search">
      <div class="form-group">
        <input type="text" placeholder="Search for Product" class="form-control" v-model="searchTerm" @keyup="searchProductsByTerm()">
      </div>
    </div>
    <div class="container content-products">
      <div class="panel-collapse panel" id="tab-live-product">
        <div class="panel__content">
          <div class="grid grid-products" :class="allProducts ? 'all' : 'draft'" v-if="!searchProducts">
            <div class="grid-col" v-for="(product, index) in products" :key="product.id" @click="clickProduct(product.id, product.variants[0].id, index)" :class="[selectedProducts.indexOf(product.id) > -1 ? 'grid-col-checked' : '', product.status]" :data-id="product.id" :data-counter="index">
              <div class="image-square">
                <img :src="product.image.src" alt=""  v-if="product.image != null" />
              </div>
            </div>
          </div>
          <div class="grid grid-products" :class="allProducts ? 'all' : 'draft'" v-if="searchProducts">
            <div class="grid-col" v-for="(product, index) in searchResults" :key="product.id" @click="clickProduct(product.id, product.variants[0].id, index)" :class="[selectedProducts.indexOf(product.id) > -1 ? 'grid-col-checked' : '', product.status]" :data-id="product.id" :data-counter="index">
              <div class="image-square">
                <img :src="product.image.src" alt=""  v-if="product.image != null" />
              </div>
            </div>
          </div>
          <div v-if="!orderPlaced" class="buttons order-buttons-box" :class="selectedProducts.length === 0 ? '' : 'grid'">
            <button class="btn btn--light drawer-toggle" data-drawer="review-order" v-if="selectedProducts.length > 0" @click="showCartDrawer()">Review Order</button>
            <button class="btn btn--primary" :disabled="selectedProducts.length === 0 || this.user.tier === null" @click="placeOrder()">Place Order</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="overlay-drawer"></div>
  <div class="drawer" id="review-order" :class="showSizes === true ? 'active-drawer' : ''">
    <div class="content container">
      <button class="drawer__close" @click="cancelSelectionOfProduct()"><i class="icon icon--down"></i></button>
      <div class="drawer__content" data-simplebar>
        <div class="heading">
          <h1>Please Select a Size</h1>
        </div>
        <div class="grid-sm">
          <li
            class="btn btn-size"
            v-for="variant in sortBySize(selectedProduct.variants)"
            :key="variant.id"
            :class="[(variant.inventory_quantity > 0 || variant.inventory > 0) ? '' : 'size-unavailable', selectedVariant === variant.id ? 'size-chosen' : '', selectedProduct.matchedSize?.includes(variant.size_name) || selectedProduct.matchedSize?.includes(variant.size) ? 'size-preselected' : '']"
            @click="selectVariant(variant.id)"
          >
          <span v-if="variant.size != null">{{ this.size(selectedProduct, variant.size) }}</span>
          <span v-if="variant.size_name != null">{{ this.size(selectedProduct, variant.size_name) }}</span>
        </li>
        </div>
        <div class="buttons order-buttons-box">
          <button class="btn btn--primary" type="button" @click="cancelSelectionOfProduct()">Cancel</button>
        </div>
      </div>
    </div>
  </div>
  <div class="drawer" id="review-orderx" :class="showCart === true ? 'active-drawer' : ''">
    <div class="content container">
      <button class="drawer__close" @click="closeDrawer"><i class="icon icon--down"></i></button>
      <div class="drawer__content" data-simplebar>
        <div class="heading">
          <h1>Review Order</h1>
        </div>
        <div class="grid grid-products">
          <div class="grid-col" v-for="(product, index) in productsInTheCart" :key="product.id" @click="removeProduct(product.id, index)" :class="[productsToRemove.indexOf(product.id) > -1 ? 'grid-col-checked grid-col-remove' : '', product.status]" :data-id="product.id">
            <div class="image-square">
              <img :src="product.product_image.src" alt=""  v-if="product.product_image != null" />
            </div>
          </div>
        </div>

        <div class="buttons order-buttons-box">
          <button class="btn btn--secondary" :disabled="productsToRemove.length === 0" v-if="productsToRemove.length < 2" @click="removeItemsFromCart()">Delete Item</button>
          <button class="btn btn--secondary" :disabled="productsToRemove.length === 0" v-if="productsToRemove.length >= 2" @click="removeItemsFromCart()">Delete Items</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'simplebar/dist/simplebar.min.css';
import Header from '../components/Header.vue';
import { reactive, toRaw } from 'vue';

export default {
  name: 'ReCreateOrder',
  components: {
    Header
  },
  data() {
    return {
      orderPlaced: false,
      order: {
        id: this.$route.params.orderid
      },
      user: {
        email: '',
        first_name: '',
        last_name: '',
        accessories: [],
        address1: '',
        address2: '',
        bottoms: [],
        city: '',
        country: '',
        fitted_hats: [],
        footwear: [],
        id: '',
        instagram_handle: '',
        phone: '',
        province: '',
        tops: [],
        zip: ''
      },
      products: null,
      showSizes: false,
      showCart: false,
      allProducts: true,
      selectedProducts: [],
      selectedVariants: [],
      productsInTheCart: [],
      productsToRemove: [],
      searchTerm: '',
      searchProducts: false,
      searchResults: [],
      selectedProduct: {},
      selectedVariant: '',
      matchedResults: true,

      userRetrieved: false,
    }
  },
  methods: {
    sortedSizes(sizes) {
      let weights = {
        'XXS': 1,
        'XS': 2,
        'S': 3,
        'M': 4,
        'L': 5,
        'XL': 6,
        'XXL': 7
      };
      let sorted = sizes.sort((a, b) => weights[a] - weights[b]);
      return sorted
    },
    sortBySize(variants) {
      const regexpCoordinates = /[a-z]/i;
      const getPoints = (size) => {
        if (regexpCoordinates.test(size)) {
          return size === 'M' ? 0 : size.length * (size.includes('S') ? -1 : 1);
        }
        return size;
      }

      if (variants && variants.length) {
        const sizeName = variants[0].size ? 'size' : 'size_name';
        return variants.map(variant => ({
          variant,
          points: getPoints(variant[sizeName])
        })).sort((a, b) => a.points - b.points).map(({ variant }) => variant);
      }
    },
    size(product, size) {
      let confirmationAttribute = this.cofirmationAttribute(product)
      let confirmed = this.user[confirmationAttribute]
      let customerSizes = this.user[product.type]
      if (customerSizes == undefined) {
        return size;
      }
      if (confirmed && customerSizes.includes(size)) {
        return `${size}*`;
      } else {
        return size
      }
    },
    cofirmationAttribute(product) {
      switch (product.type) {
        case 'fitted_hats':
          return 'headwear_sizes_confirmed';
        case 'tops':
          return 'tops_sizes_confirmed';
        case 'bottoms':
          return 'bottoms_sizes_confirmed';
        case 'footwear':
          return 'footwear_sizes_confirmed';
        case 'accessories':
          return 'accessories_sizes_confirmed';
        default:
          return 'accessories_sizes_confirmed';
      }
    },
    sortedHeadWearSizes(sizes) {
      let weights = {
        "OS": 1,
        "S/M": 2,
        "L/XL": 3,
        "7": 4,
        "7⅛": 5,
        "7¼": 6,
        "7⅜": 7,
        "7½": 8,
        "7⅝": 9,
        "7¾": 10,
        "7⅞": 11
      }
      let sorted = sizes.sort((a, b) => weights[a] - weights[b]);
      return sorted
    },
    selectVariant(variantid) {
      const item = this.selectedProduct.variants.find(v => v.id === variantid);
      item.title = this.selectedProduct.title;
      item.productId = this.selectedProduct.id;
      item.quantity = 1;
      item.image = this.selectedProduct.image?.src || this.selectedProduct.image_url;
      this.selectedVariants.push(item);
      this.showSizes = false;
      document.body.classList.toggle('drawer-open');
    },
    cancelSelectionOfProduct() {
      this.showSizes = false;
      document.body.classList.toggle('drawer-open');
      this.selectedProducts.pop();
      this.productsInTheCart.pop();
    },
    searchProductsByTerm() {
      if(this.searchTerm.length > 0) {
        this.searchProducts = true;
        this.searchResults = this.products.filter((element, index) => {
          console.log(element, index)
          return element.title.toLowerCase().indexOf(this.searchTerm.toLowerCase()) > -1
        });
        console.log(this.searchResults);
      } else {
        this.searchProducts = false;
      }
      return false;
    },
    clearSearch() {
      this.searchProducts = false;
      this.searchResults = [];
      this.searchTerm = '';
    },
    clickProduct(id, variantid, idx) {
      let index = this.selectedProducts.indexOf(id);
      if(index > -1) {
        // this.selectedProducts.splice(index, 1);
        // add removing from the cart
      } else {
        this.selectedProducts.push(id);
        // this.selectedVariants.push(variantid)
        // const productObj = ref(this.products[idx])
        // const productObjExt = reactive(this.products[idx])
        let tempProducts = this.products;
        console.log(tempProducts[idx], idx);

        console.log('---------------');
        let tempProd = toRaw(reactive(this.products[idx]))
        let footwearSizing = this.user.footwear;
        let topsSizing = this.user.tops;
        let accessoriesSizing = this.user.accessories;
        let bottomsSizing = this.user.bottoms;
        let fittedHatsSizing = this.user.fitted_hats;
        const accessoriesNames = ['accessories', 'bags', 'jewelry'];
        const topsNames = ['tees', 'outerwear', 'shirting', 'knits', 'sweatshirt', 'sweatshirts', 'suits', 'hoodies', 'sweaters', 'knitwear1', 'knitwear', 'woven shirts', 'crewneck', 'shirt'];
        const hatsNames = ['headwear', 'hats'];
        const footwearNames = ['footwear', 'shoes'];
        const bottomsNames = ['pants', 'shorts', 'sweats', 'sweatpants', 'sweatshorts', 'belt'];
        if (tempProd.product_collections !== undefined) {
        if (tempProd.product_collections.some(r => footwearNames.includes(r))) {
          tempProd.matchedSize = footwearSizing;
        } else if (tempProd.product_collections.some(r => accessoriesNames.includes(r))) {
          tempProd.matchedSize = accessoriesSizing
        } else if (tempProd.product_collections.some(r => bottomsNames.includes(r))) {
          tempProd.matchedSize = bottomsSizing
        } else if (tempProd.product_collections.some(r => topsNames.includes(r))) {
          tempProd.matchedSize = topsSizing
        } else if (tempProd.product_collections.some(r => hatsNames.includes(r))) {
          tempProd.matchedSize = fittedHatsSizing
        }
      } else if (tempProd.product_type !== undefined) {
        const productType = tempProd.product_type.toLowerCase();
        if (footwearNames.includes(productType)) {
          tempProd.matchedSize = footwearSizing;
        } else if (accessoriesNames.includes(productType)) {
          tempProd.matchedSize = accessoriesSizing
        } else if (bottomsNames.includes(productType)) {
          tempProd.matchedSize = bottomsSizing
        } else if (topsNames.includes(productType)) {
          tempProd.matchedSize = topsSizing
        } else if (hatsNames.includes(productType)) {
          tempProd.matchedSize = fittedHatsSizing
        }
      } else {
        tempProd.matchedSize = '';
      }

        this.productsInTheCart.push(toRaw(reactive(this.products[idx])));

        this.selectedProduct = toRaw(reactive(this.products[idx]))
        console.log('> selected product', this.selectedProduct)

        this.showSizes = true;
        document.body.classList.toggle('drawer-open');
      }
      console.log(this.selectedProducts, this.showSizes, this.selectedVariants)
    },
    removeItemsFromCart() {
      console.log('remove selected items from the cart');
      for(var i in this.productsToRemove) {
        console.log(this.productsToRemove[i]);
        for(var j in this.productsInTheCart) {
          if(this.productsInTheCart[j].id === this.productsToRemove[i]) {
            this.productsInTheCart.splice(j, 1);
          }
        }

        var selProdId = this.selectedProducts.indexOf(this.productsToRemove[i]);
        this.selectedVariants.splice(selProdId, 1);
        this.selectedProducts.splice(selProdId, 1);
      }
      this.productsToRemove = [];
      console.log(this.productsToRemove, this.productsInTheCart, this.selectedVariants, this.selectedProducts)
    },
    removeProduct(id, idx) {
      console.log('remove', id, idx)
      let index = this.productsToRemove.indexOf(id);
      if(this.productsToRemove.indexOf(id) > -1) {
        this.productsToRemove.splice(index, 1);
      } else {
        this.productsToRemove.push(id)
      }
      console.log(this.productsToRemove)
    },
    closeDrawer() {
      this.showSizes = false;
      this.showCart = false;
      document.body.classList.toggle('drawer-open');
    },
    placeOrder() {
      this.axios.post(`/v1/customers/${this.user.id}/orders.json`, {
        record: {
          location: this.order.location,
          shipping_method: this.user.shipping_method || 'standard',
          variant_ids: this.selectedVariants,
          recreated_order_id: this.order.order_number,
          drafted_by: this.currentUser.name,
        }
      }).then(() => {
        this.orderPlaced = true
        setTimeout(this.redirectToHome, 3000);
      })
     .catch((error) => { console.log(error) });
    },
    redirectToHome() {
      this.$router.push('/home/');
    },
    liveProductActive() {
      this.allProducts = true;
    },
    draftProductActive() {
      this.allProducts = false;
    },
    showCartDrawer() {
      this.showCart = true;
      document.body.classList.toggle('drawer-open');
    },
    loadResults() {
      console.log(this.matchedResults, 'filters?');

      if(this.matchedResults) {
        this.axios.get('/v1/products.json').then(response => {
          let products = response.data.records;
          this.products = products;
        }).catch((error) => { console.log(error) });
      } else {
        console.log(this.matchedResults, 'filters on');
        let appurl = 'aime-leon-dore-dev-store';
        if(process.env.NODE_ENV === 'production') {
          appurl = 'aime-leon-dore';
        }
        this.axios({
          url: 'https://api.aimeleondore.com/api/filter_products',
          method: 'post',
          data: {
            collection: "shop-all",
            store_name: appurl,
            sizes: ['S'],
            seeding_app: true
          }
        }).then(response => {
          console.log('then', response)
        }).catch(error => {
          console.log('error', error)
        })
      }
    }
  },
  mounted() {
    console.log(this.matchedResults, 'filters?')

    this.axios({
      method: 'get',
      url: `/v1/orders/numbered/${this.order.id}.json`,
    })
    .then(response => {
      this.order = response.data.record
      this.user = response.data.record.customer;
      console.log(response.data.record, '<< order');

      let lineitems = response.data.record.line_items;

      for(var i in lineitems) {
        var lineItem = {
          id: lineitems[i].variant_id,
          quantity: lineitems[i].quantity,
        }

        this.selectedProducts.push(lineitems[i].id)
        this.selectedVariants.push(lineItem)
        this.productsInTheCart.push(lineitems[i])
      }

        // this.selectedProducts.push(id);
        // let tempProducts = this.products;
        // let tempProd = toRaw(reactive(this.products[idx]))
        // this.productsInTheCart.push(toRaw(reactive(this.products[idx])));


      this.axios.get(`/v1/customers/${this.user.id}.json`).then(response => {
        this.user = response.data.record;
        this.userRetrieved = true;
      }).catch((error) => { console.log(error) });

      this.axios.get('/v1/products.json').then(response => {
        let products = response.data.records
        this.products = products;
      }).catch((error) => { console.log(error) });
    })
   .catch((error) => { console.log(error) });
  }
}
</script>
